export default __webpack_public_path__ + "static/me-83b4dea710ffa2c0c3007b2a69c11fd4.png";